<!-- Footer Section -->
<footer>
  <div class="footer-container">
    <div class="footer-left">
      <h3>Coinwush</h3>
      <!-- <p class="font-medium text-500">
        Coinwush Exchange is a cutting-edge crypto derivatives trading platform
        designed for traders seeking speed, security, and advanced trading
        tools.
      </p> -->

      <!-- Social Media Links -->
      <div class="footer-social">
        <!-- <h4 class="font-normal text-base">Follow Us</h4> -->
        <div class="social-links">
          <a href="#" aria-label="Twitter" class="social-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
              />
            </svg>
          </a>
          <a href="#" aria-label="Telegram" class="social-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"
              />
            </svg>
          </a>
          <a href="#" aria-label="Discord" class="social-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"
              />
            </svg>
          </a>
          <a href="#" aria-label="LinkedIn" class="social-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-column">
      <h4 class="font-normal text-base">Company</h4>
      <ul>
        <li>
          <a [routerLink]="['/about']" class="text-500 font-normal text-sm"
            >About us</a
          >
        </li>
        <li>
          <a
            [routerLink]="['/risk-disclosure']"
            class="text-500 font-normal text-sm"
            >Risk Disclosure</a
          >
        </li>
      </ul>
    </div>

    <div class="footer-column">
      <h4 class="font-normal text-base">Reference</h4>
      <ul>
        <li>
          <a [routerLink]="['/support']" class="text-500 font-normal text-sm"
            >Support Center</a
          >
        </li>
        <li>
          <a [routerLink]="['/fees']" class="text-500 font-normal text-sm"
            >Fees</a
          >
        </li>
      </ul>
    </div>

    <div class="footer-column">
      <h4 class="font-normal text-base">Policies</h4>
      <ul>
        <li>
          <a
            [routerLink]="['/terms-conditions']"
            class="text-500 font-normal text-sm"
            >T&C</a
          >
        </li>
        <li>
          <a [routerLink]="['/aml-policy']" class="text-500 font-normal text-sm"
            >AML/KYC/CFT</a
          >
        </li>
        <li>
          <a
            [routerLink]="['/privacy-policy']"
            class="text-500 font-normal text-sm"
            >Privacy Policy</a
          >
        </li>
      </ul>
    </div>

    <div class="footer-column">
      <h4 class="font-normal text-base">Contact & Support</h4>
      <ul>
        <li>
          <a
            href="mailto:support@coinwush.com"
            class="text-500 font-normal text-sm"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              class="inline-icon"
            >
              <path
                d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <polyline
                points="22,6 12,13 2,6"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            support&#64;coinwush.com
          </a>
        </li>
        <li>
          <a [routerLink]="['/support']" class="text-500 font-normal text-sm">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              class="inline-icon"
            >
              <circle cx="12" cy="12" r="10" stroke-width="2" />
              <path
                d="M12 16v-4M12 8h.01"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Help Center
          </a>
        </li>
        <!-- <li>
          <a href="#" class="text-500 font-normal text-sm">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              class="inline-icon"
            >
              <path
                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Live Chat
          </a>
        </li> -->
      </ul>
    </div>
  </div>

  <!-- Risk Disclaimer Section -->
  <!-- <div class="surface-50 border-top-1 border-200 py-4">
    <div class="mx-5">
      <div class="surface-0 border-1 border-red-200 border-round p-4 bg-red-50">
        <div class="flex gap-2 mb-2">
          <i class="pi pi-exclamation-triangle text-red-400 text-lg"></i>
          <h4 class="text-base font-semibold text-800 m-0">
            Important Risk Disclaimer
          </h4>
        </div>
        <p class="text-sm text-700 font-normal line-height-3 m-0 pl-4">
          Cryptocurrency derivatives products are unregulated and carry a high
          level of risk. There may be no regulatory recourse for any loss from
          such transactions. Digital assets are not legal tender and are not
          recognized or backed by the Reserve Bank of India or any other
          regulatory authority. Trading in cryptocurrency derivatives is
          speculative and you should only trade with funds you can afford to
          lose entirely.
        </p>
      </div>
    </div>
  </div> -->

  <!-- Copyright Bar -->
  <div class="surface-100 border-top-1 border-200 py-3">
    <div class="text-center">
      <p class="text-600 font-normal text-sm m-0">
        © 2025 Coinwush Exchange. All rights reserved.
      </p>
    </div>
  </div>
</footer>
